import { render, staticRenderFns } from "./poi-slide-video.vue?vue&type=template&id=2c8ef987&"
import script from "./poi-slide-video.vue?vue&type=script&lang=ts&"
export * from "./poi-slide-video.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports